import { Button } from '@astryxdesign/core/Button';
import { Card } from '@astryxdesign/core/Card';
import { HStack, VStack } from '@astryxdesign/core/Stack';
import { Text } from '@astryxdesign/core/Text';
import { DeviceMobile, Export, PlusSquare } from '@phosphor-icons/react';
import { useInstall } from '../lib/pwa';
import { useStudio } from '../app/studio';

/** "Add to home screen": a real prompt on Android/desktop Chrome, steps on iPhone. */
export function InstallCard() {
  const studio = useStudio();
  const { mode, install } = useInstall();
  if (mode === 'installed' || mode === 'none') return null;
  return (
    <VStack paddingInline={4}>
      <Card padding={5} variant="muted">
        <VStack gap={3}>
          <HStack gap={3} vAlign="center">
            <DeviceMobile size={28} color="var(--color-accent)" aria-hidden />
            <Text weight="semibold" type="large">
              Приложение {studio.short_name} на телефоне
            </Text>
          </HStack>
          {mode === 'prompt' ? (
            <>
              <Text color="secondary">Откроется с главного экрана, без адресной строки — запись в одно касание.</Text>
              <Button label="Добавить на главный экран" variant="primary" clickAction={async () => void (await install())} />
            </>
          ) : (
            <VStack gap={2}>
              <Text color="secondary">В Safari:</Text>
              <HStack gap={2} vAlign="center">
                <Export size={20} aria-hidden />
                <Text>нажмите «Поделиться»</Text>
              </HStack>
              <HStack gap={2} vAlign="center">
                <PlusSquare size={20} aria-hidden />
                <Text>выберите «На экран „Домой“»</Text>
              </HStack>
              <Text type="supporting">После установки приложение сможет присылать напоминания о записи.</Text>
            </VStack>
          )}
        </VStack>
      </Card>
    </VStack>
  );
}
